module.exports = __webpack_public_path__ + "static/media/stock1.98279e1a.png";